import {
  getFdEarlyPrice,
  getFdWindowMs,
} from '@/buyer-portal/components/features/listing/hooks/useFdActiveGroup'
import type { FirstDibsGroup } from '@/queries/listingDetailsQuery'

/**
 * First Dibs properties for Segment events (BP-2977): the buyer's open group
 * and when its window closes, plus the early Buy Now price where the buyer
 * can act on it. Empty when no window is open, so other events never carry
 * the keys. Names are provisional until Data Eng confirms them.
 */
export const toFirstDibsSegmentProps = (
  group: FirstDibsGroup | undefined,
  { withEarlyPrice = false }: { withEarlyPrice?: boolean } = {}
) => {
  const window = group && getFdWindowMs(group)
  if (!group || !window) return {}

  return {
    first_dibs_window_open: true,
    first_dibs_buyer_group_id: group.buyerGroupId,
    first_dibs_window_end: new Date(window.endMs).toISOString(),
    // null (not omitted) for bid-only groups, so "no early price" is explicit
    ...(withEarlyPrice && {
      first_dibs_early_price: getFdEarlyPrice(group) ?? null,
    }),
  }
}
